import { forwardRef } from "react"
import { Button, type ButtonProps } from "./button/base"

/** Step on the shared v2 control ladder the visible box sits on. */
export type IconButtonSize = "2xs" | "xs" | "sm" | "md"

export interface IconButtonProps
  extends Omit<ButtonProps, "variant" | "size" | "state"> {
  /** Toggled-on look (for example, an open menu trigger). */
  active?: boolean
  /**
   * Visible box on the v2 control ladder: `2xs` 24px, `xs` 28px, `sm` 32px,
   * `md` 36px. Defaults to `md`. Every step keeps the same 40px hit area.
   */
  size?: IconButtonSize
}

/**
 * Ghost icon button — `Button` with `variant="icon"`.
 *
 * Prefer this name at call sites where `size="md"` must mean the 36px icon box,
 * not the 36px labelled button. It is not a second primitive: press, ripple and
 * focus live on `Button`.
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ size = "md", ...rest }, ref) => (
    <Button ref={ref} size={size} variant="icon" {...rest} />
  ),
)

IconButton.displayName = "IconButton"
